/*jshint esversion: 11 */
import React from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input
} from 'reactstrap';
import { connect } from 'react-redux';
import PageDataLoader from '../Utility/PageDataLoader';
import moment from 'moment';

const ViewAttendanceModal = ({
  modalOpenState,
  closeModalHandler,
  attendaceInfoLoading,
  attendanceInfo,
  authUser
}) => {
  return (
    <React.Fragment>
      <Modal isOpen={modalOpenState} backdrop="static" size="lg">
        <ModalHeader toggle={closeModalHandler}>
          {attendaceInfoLoading
            ? 'Loading ...'
            : attendanceInfo?.leave_reason || ''}
        </ModalHeader>
        <ModalBody>
          {attendaceInfoLoading ? (
            <div className="d-flex justify-content-center">
              <PageDataLoader />
            </div>
          ) : (
            <React.Fragment>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Reason</Label>
                    <Input
                      name="title"
                      type="text"
                      className="form-control"
                      value={attendanceInfo?.leave_reason || ''}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Start Date</Label>
                    <Input
                      name="start_date"
                      type="text"
                      className="form-control"
                      value={
                        attendanceInfo?.start_date
                          ? moment(attendanceInfo.start_date).format(
                              'DD-MM-YYYY'
                            )
                          : ''
                      }
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>End Date</Label>
                    <Input
                      name="end_date"
                      type="text"
                      className="form-control"
                      value={
                        attendanceInfo?.end_date
                          ? moment(attendanceInfo.end_date).format('DD-MM-YYYY')
                          : ''
                      }
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Status</Label>
                    <Input
                      name="status"
                      type="text"
                      className="form-control"
                      value={attendanceInfo?.status || ''}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Type</Label>
                    <Input
                      name="type"
                      type="text"
                      className="form-control"
                      value={attendanceInfo?.type || ''}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                {authUser?.user_type === 'super_admin' && (
                  <Col md="6">
                    <FormGroup>
                      <Label>Marked By</Label>
                      <Input
                        name="marked_by"
                        type="text"
                        className="form-control"
                        value={attendanceInfo?.marked_by?.name || ''}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                )}
                {authUser?.user_type === 'staff' && (
                  <Col md="6">
                    <FormGroup>
                      <Label>Leave Left</Label>
                      <Input
                        name="leave_left"
                        type="text"
                        className="form-control"
                        value={`${authUser?.leaves?.paid || 0} / 10`}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <ModalFooter>
                <Button type="button" color="light" onClick={closeModalHandler}>
                  Close
                </Button>
              </ModalFooter>
            </React.Fragment>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  authUser: state.Login?.user
});

export default connect(mapStateToProps)(ViewAttendanceModal);
